export const ASSISTANCE_PROGRAMS_RESET_STATE = 'ASSISTANCE_PROGRAMS_RESET_STATE';
export const ASSISTANCE_PROGRAMS_CURRENT_ITEM = 'ASSISTANCE_PROGRAMS_CURRENT_ITEM';

export const ASSISTANCE_PROGRAMS_REQUEST_LOADING = 'ASSISTANCE_PROGRAMS_REQUEST_LOADING';
export const ASSISTANCE_PROGRAMS_REQUEST_SUCCESS = 'ASSISTANCE_PROGRAMS_REQUEST_SUCCESS';
export const ASSISTANCE_PROGRAMS_REQUEST_FAILED = 'ASSISTANCE_PROGRAMS_REQUEST_FAILED';

export const ASSISTANCE_PROGRAMS_CURRENT_ACTION = 'ASSISTANCE_PROGRAMS_CURRENT_ACTION';
export const ASSISTANCE_PROGRAMS_RESET_ACTION = 'ASSISTANCE_PROGRAMS_RESET_ACTION';